import {
  ALL_ID,
  ProfileV2ComponentAttributes,
  ProfileV2Renderer,
} from '@loyalty/editor-components';
import { Editor } from 'grapesjs';
import { faIdCardAlt } from '@fortawesome/pro-solid-svg-icons/faIdCardAlt';
import { EditorComponentDefinition } from '../types';
import { EditorContext } from '../../../services/editor-service';
import { ProfileV2WidgetTraits } from './ProfileV2WidgetTraits';
import { Toolbar, buildParticipantContextFromGrape } from '../../utils';

const CLASSNAME = 'qlfeditor-profile';

export const profileV2ComponentDefinition: EditorComponentDefinition = {
  id: 'profile-v2',
  icon: faIdCardAlt,
  category: 'Profile',
  getLabel: ({ t }) => t('editor.component.profile'),
  component: ProfileWidget,
  traits: {
    form: ProfileV2WidgetTraits,
  },
};

function ProfileWidget(editor: Editor) {
  const i18n = editor.I18n;

  editor.DomComponents.addType(profileV2ComponentDefinition.id, {
    isComponent: (el: HTMLElement) => {
      return el.tagName === 'DIV' && el.classList.contains(CLASSNAME);
    },
    model: {
      defaults: {
        tagName: 'div',
        category: 'content',
        attributes: {
          showProfilePicture: true,
          showProfileName: true,
          showLevel: true,
          showCurrencyBalance: true,
          profileNameFormat: 'fullname',
          currencyId: ALL_ID,
        } as ProfileV2ComponentAttributes,
        content: '',
        droppable: false,
        draggable: '[data-gjs-type=column]',
        traits: [],
      },
      initToolbar: Toolbar,
      toHTML(): string {
        return ProfileV2Renderer(
          {
            state: (editor.Config?.context as EditorContext).widgetState,
            options: {
              id: this.getId(),
              attributes: this.getAttributes(),
              i18nAttributes: this.attributes.i18nAttributes || {},
            },
            context: buildParticipantContextFromGrape(i18n),
          },
          editor.Canvas.getDocument(),
        );
      },
    },
    view: {
      onRender() {
        const { el, model } = this;
        el.innerHTML = model.toHTML();
      },
    },
  });
}
